<template>
  <div>
    <h4>{{ $t("room.illumination.flicker.index") }}</h4>
    <v-row class="mx-0 my-3 d-flex justify-space-between align-baseline">
      <span class="caption black20">
        {{ $t("tests.illumination.measurement_card.required") }}
      </span>
      <span class="body2">{{ requiredFlickerIndexLabel }}</span>
    </v-row>
    <v-row class="mx-0 my-3 d-flex justify-space-between align-baseline">
      <span class="caption black20">
        {{ $t("tests.illumination.measurement_card.measured") }}
      </span>
      <span class="body2">{{ measuredFlickerIndexLabel }}</span>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "flicker-index-card-info",
  props: ["test"],
  computed: {
    requiredFlickerIndexLabel() {
      const { required_flicker_index } = this.test;
      if (
        required_flicker_index === null ||
        required_flicker_index === undefined
      ) {
        return "-";
      }
      return required_flicker_index;
    },
    measuredFlickerIndexLabel() {
      const { measured_flicker_index } = this.test;
      if (
        measured_flicker_index === null ||
        measured_flicker_index === undefined
      ) {
        return "-";
      }
      return measured_flicker_index;
    },
  },
};
</script>

<style scoped>
.black20 {
  color: #333333;
  font-weight: 500;
}
</style>
